import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    exportExcelChannel = new Subject();
    indexChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.indexChannel.next({status: apiResponse.INITIAL})
    }

    fetchExportExcel = async (query) => {
        this.exportExcelChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchExportExcel(query).then((result) => {
            this.exportExcelChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.exportExcelChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

   
}

export default IndexBloc